{{opened ? text : excerpt }}

<div class="see_more" (click)="toggleState()" [hidden]="!has_excerpt">
  <span>{{(opened ? 'commons.see_less' : 'commons.see_more') | translate }}</span>
  <i class="fal fa-angle-{{opened ? 'up' : 'down' }}"></i>
</div>